var _circle, _circle2, _path, _path2, _path3, _rect, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetTypeAb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 38.5,
    stroke: "#4FC7E4",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 28.5,
    stroke: "#4FC7E4",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2815 93.7313C16.5808 95.2328 17.2299 97.0179 18.7313 97.7185C20.2328 98.4192 22.0179 97.7701 22.7185 96.2687L17.2815 93.7313ZM24.2815 78.7313L17.2815 93.7313L22.7185 96.2687L29.7185 81.2687L24.2815 78.7313Z",
    fill: "#4FC7E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2815 96.2683C77.9823 97.7697 79.7674 98.4187 81.2688 97.718C82.7702 97.0173 83.4192 95.2321 82.7185 93.7307L77.2815 96.2683ZM82.7185 93.7307L75.7177 78.7311L70.2807 81.2687L77.2815 96.2683L82.7185 93.7307Z",
    fill: "#4FC7E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6711 54.464H34.0391L33.1991 57.824H27.9911L34.0151 38.264H38.8631L45.0071 57.824H39.5111L38.6711 54.464ZM37.7351 49.712L36.5111 43.976H36.4391L35.0711 49.712H37.7351Z",
    fill: "#4FC7E4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 27.5,
    width: 3,
    height: 45,
    fill: "#4FC7E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6353 38.384C64.3553 38.384 65.0673 38.48 65.7713 38.672C66.4913 38.848 67.1313 39.16 67.6913 39.608C68.2673 40.056 68.7153 40.64 69.0353 41.36C69.3713 42.064 69.5233 42.928 69.4913 43.952C69.4433 44.64 69.2993 45.232 69.0593 45.728C68.8353 46.224 68.5313 46.672 68.1473 47.072C68.8833 47.536 69.5633 48.176 70.1873 48.992C70.8273 49.808 71.1473 50.8 71.1473 51.968C71.1473 53.136 70.8433 54.176 70.2353 55.088C69.6433 56 68.9953 56.672 68.2913 57.104C67.6033 57.536 66.8513 57.824 66.0353 57.968C65.2193 58.112 64.4513 58.184 63.7313 58.184H57.4433V38.384H63.6353ZM62.1953 49.136V51.176C62.1953 51.896 62.2033 52.592 62.2193 53.264H63.1073C63.4753 53.264 63.8353 53.24 64.1873 53.192C64.5553 53.128 64.8673 53.032 65.1233 52.904C65.3953 52.76 65.6113 52.552 65.7713 52.28C65.9473 52.008 66.0353 51.624 66.0353 51.128C66.0353 50.68 65.9393 50.328 65.7473 50.072C65.5713 49.8 65.3393 49.592 65.0513 49.448C64.7793 49.304 64.4673 49.216 64.1153 49.184C63.7793 49.152 63.4433 49.136 63.1073 49.136H62.1953ZM62.2193 42.176V43.928C62.2193 44.216 62.2113 44.512 62.1953 44.816C62.1953 45.104 62.1953 45.408 62.1953 45.728H63.0833C63.2913 45.728 63.5153 45.712 63.7553 45.68C63.9953 45.632 64.2113 45.536 64.4033 45.392C64.5953 45.248 64.7553 45.064 64.8833 44.84C65.0273 44.616 65.0993 44.32 65.0993 43.952C65.0833 43.264 64.8753 42.8 64.4753 42.56C64.0913 42.304 63.5953 42.176 62.9873 42.176H62.2193Z",
    fill: "#4FC7E4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetTypeAb);
export default __webpack_public_path__ + "static/media/target-type-AB.8e71788b1e8f6b0b9bc917dd8cb9816d.svg";
export { ForwardRef as ReactComponent };